import { getAdditionalEnrollmentStatuses } from 'utils/enrollmentStatuses';
import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Text, Select, Box, useToast, Button } from '@chakra-ui/react';
import xhr from 'xhr';
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import useAuth from 'hooks/useAuth';

function BuscarFiltro() {
  const navigate = useNavigate();
  const [programTypes, setProgramsTypes] = React.useState([]);

  const [semester, setSemester] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [programs, setPrograms] = React.useState([]);
  const [currentProgramType, setCurrentProgramType] = React.useState('');
  const [currentProgram, setCurrentProgram] = React.useState('');
  const { user } = useAuth();

  const [fetching, isFetching] = React.useState(true);

  const getPrograms = async (event) => {
    const programType = programTypes.find((el) => el.slug === event.target.value);

    if (programType) {
      const programsResponse = await xhr(
        `/${programType.type.replace('_', '-')}s?filters[program_type][id][$eq]=${
          programType.id
        }&filters[active][$eq]=true`
      );

      setPrograms(
        programsResponse.data.data.map((el) => {
          return { ...el, label: el.name, value: el.id };
        })
      );

      setCurrentProgramType(programType);
    }
  };

  React.useEffect(() => {
    const getProgramTypes = async () => {
      try {
        const res = await xhr(`/program-types?filters[active][$eq]=true`);

        if (user?.school) {
          setProgramsTypes(
            res.data.data
              .filter((el) => el.id === 4 || el.id === 5)
              .map((el) => {
                return { ...el, label: el.name, value: el.slug };
              })
          );
        } else {
          setProgramsTypes(
            res.data.data.map((el) => {
              return { ...el, label: el.name, value: el.slug };
            })
          );
        }
      } catch (error) {
      } finally {
        isFetching(false);
      }
    };
    getProgramTypes();
  }, []);

  React.useEffect(() => {
    const getSemester = async () => {
      try {
        let semUrl = '/semesters?pagination[limit]=-1';
        if (user?.school) {
          semUrl += `&filters[school][id][$eq]=${user.school.id}`;
        } else {
          semUrl += '&filters[$or][0][school][id][$null]=true&filters[$or][1][school][id][$eq]=0';
        }
        const res = await xhr(semUrl);
        setSemester(
          res.data.data.map((el) => {
            return { ...el, label: el.name, value: el.id };
          })
        );
      } catch (error) {
      } finally {
        isFetching(false);
      }
    };
    getSemester();
  }, []);

  const BasicInfoSchema = Yup.object().shape({
    program_type: Yup.string().required('Requerido'),
    program: Yup.string().required('Requerido'),
    status: Yup.string().required('Requerido'),
    semester: Yup.string().required('Requerido'),
  });

  const [loading, setLoading] = React.useState(false);

  const toasts = useToast();

  const handleFilter = async (values, action) => {
    let url = `/plataforma/administrador/filtro?program_type=${values.program_type}&program=${values.program}`;

    // if (values.group) url = url + `&group=${values.group}`;
    if (values.status) url = url + `&status=${values.status}`;
    if (values.semester) url = url + `&semester=${values.semester}`;
    // if (values.period) url = url + `&period=${values.period}`;

    navigate(url);
  };

  return (
    <>
      <Box w="50%">
        <Text fontSize="28px" fontWeight="bold">
          Buscar
        </Text>
        <Box marginTop="20px">
          <Formik
            initialValues={{
              program_type: '',
              program: '',
              period: '',
              status: '',
              semester: '',
            }}
            validationSchema={BasicInfoSchema}
            onSubmit={handleFilter}
          >
            {(data) => {
              return (
                <Form>
                  <Field as={Select} name={'program_type'} placeholder="Seleccionar" onChangeCapture={(event) => {
                    getPrograms(event);
                    data.setFieldValue('status', '');
                  }}>
                    {programTypes.map((el, index) => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name={'program_type'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>

                  <Field
                    marginTop="20px"
                    name="program"
                    label="Programa"
                    as={Select}
                    placeholder="Seleccionar"
                    onChangeCapture={(event) => setCurrentProgram(Number(event.target.value))}
                  >
                    {programs.map((el, index) => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name={'program'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>

                  {/* <Field marginTop="20px" name="group" label="Grupo" as={Select} placeholder="Seleccionar Grupo">
                    {groups.map((el, index) => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field> */}

                  <br />
                  <Field name="status" placeholder="Estado" as={Select}>
                    <option value="registrado">Registrado</option>
                    <option value="estudiando">Estudiando</option>
                    <option value="promovido">Promovido</option>
                    <option value="graduado">Graduado</option>
                    <option value="retirado">Retirado</option>
                    {getAdditionalEnrollmentStatuses(currentProgramType?.type).map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </Field>
                  <ErrorMessage name={'status'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>
                  <br />
                  <Field name="semester" placeholder="Semestre" as={Select}>
                    {semester.map((el, index) => (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    ))}
                  </Field>

                  <ErrorMessage name={'semester'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>
                  <br />

                  {data.values.program_type === 'carreras-tecnicas' && (
                    <Field name="period" label="Periodo" color="black" placeholder="Periodo" as={Select}>
                      <option value="P1">Periodo 1</option>
                      <option value="P2">Periodo 2</option>
                      <option value="P3">Periodo 3</option>
                      <option value="P4">Periodo 4</option>
                    </Field>
                  )}

                  <br />

                  <Button type="submit" colorScheme="#574feb" bg="#574feb" width="140px" isLoading={loading}>
                    Buscar
                  </Button>
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Box>
    </>
  );
}

export default BuscarFiltro;
